import React, { useEffect, useState } from "react"
import { ProgressBarContainer, ProgressBarItem } from "./style"

const PRELOAD_OFFSET = 1200

const ProgressBar = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const calculatePercentage = ({ PRELOAD_OFFSET: preloadOffset }) => {
      const scrolledValue =
        window.scrollY + document.documentElement.clientHeight

      const totalValue =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight +
        (preloadOffset || 0)

      const percentageValue = (scrolledValue / totalValue) * 100
      setProgress(percentageValue)
    }

    calculatePercentage({ PRELOAD_OFFSET })
    document.addEventListener("scroll", calculatePercentage)

    return () => {
      document.removeEventListener("scroll", calculatePercentage)
    }
  }, [])

  return (
    <ProgressBarContainer>
      <ProgressBarItem progressPercentage={progress} />
    </ProgressBarContainer>
  )
}
export default ProgressBar
